import {
    AuditOutlined,
    CalendarOutlined,
    ControlOutlined,
    DashboardOutlined,
    HistoryOutlined,
    LinkOutlined,
    SafetyCertificateOutlined,
    ScheduleOutlined,
    SettingOutlined,
    SolutionOutlined,
    TeamOutlined,
    UnorderedListOutlined,
    UserOutlined
} from '@ant-design/icons-vue';

/**
 * 側邊選單。section 是圖二那種分組標題，不是可點的資料夾。
 * group 才是會展開的子選單。
 */
export const sideNavSections = [
    {
        key: 'all',
        title: '全部',
        entries: [
            { kind: 'dashboard', label: '儀表板', icon: DashboardOutlined },
            {
                kind: 'calendar',
                label: '行事曆',
                path: '/schedule-calendar',
                icon: CalendarOutlined
            }
        ]
    },
    {
        key: 'consultant',
        title: '諮詢師',
        entries: [
            {
                kind: 'route',
                name: 'ConsultationWorkspaceClients',
                label: '我的學員',
                icon: TeamOutlined
            },
            {
                kind: 'route',
                name: 'ConsultationWorkspaceBookings',
                label: '我的預約',
                icon: ScheduleOutlined
            }
        ]
    },
    {
        key: 'manage',
        title: '管理',
        entries: [
            {
                kind: 'route',
                name: 'FinanceVersionList',
                label: '版本列表',
                icon: HistoryOutlined
            },
            {
                kind: 'route',
                name: 'Consultations',
                label: '預約列表',
                icon: UnorderedListOutlined
            },
            {
                kind: 'group',
                label: '資料設置',
                icon: SettingOutlined,
                children: [
                    { name: 'TypeList', label: '類型管理' },
                    { name: 'OptionList', label: '選項管理' }
                ]
            },
            {
                kind: 'group',
                label: '諮詢設置',
                icon: SolutionOutlined,
                children: [
                    { name: 'ConsultationLevels', label: '等級設置' },
                    { name: 'Consultants', label: '諮詢師管理' },
                    { name: 'BookingScheduleManage', label: '預約與排班管理' },
                    { name: 'BookingWindowSettings', label: '參數設置' }
                ]
            }
        ]
    },
    {
        key: 'engineer',
        title: '工程師',
        entries: [
            {
                kind: 'route',
                name: 'GrowthMemberLinks',
                label: '世界樹對照',
                icon: LinkOutlined
            },
            {
                kind: 'route',
                name: 'BookingParams',
                label: '完整參數設置',
                icon: ControlOutlined
            },
            {
                kind: 'route',
                name: 'ConsultationTicketSettings',
                label: '諮詢卷開關',
                icon: ControlOutlined
            },
            {
                kind: 'route',
                name: 'OperationLog',
                label: '操作紀錄',
                icon: AuditOutlined
            },
            {
                kind: 'route',
                name: 'RoleManagement',
                label: '角色列表',
                icon: SafetyCertificateOutlined
            },
            {
                kind: 'route',
                name: 'AdminList',
                label: '管理員列表',
                icon: UserOutlined
            }
        ]
    }
];
